import { Navigate, Outlet } from "react-router";
import { MODIFY, PRODUCT_SETTINGS_ORGANIZATION, useFoodpilotContext } from "src/context/FoodpilotContext";

export const PackagingSsqProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(MODIFY, PRODUCT_SETTINGS_ORGANIZATION)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
